import { useEffect, useState } from "react";

export function useOfferCheckoutUrl(defaultUrl: string): string {
  const [url, setUrl] = useState(defaultUrl);

  useEffect(() => {
    setUrl(defaultUrl);
    try {
      const searchParams = new URLSearchParams(window.location.search);
      const next = new URL(defaultUrl);
      let changed = false;

      // Parâmetros para propagar
      const paramsToPass = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "ponto", "visita", "trk", "trk2"];

      paramsToPass.forEach(param => {
        const val = searchParams.get(param);
        if (val) {
          next.searchParams.set(param, val);
          changed = true;
        }
      });

      if (changed) {
        setUrl(next.toString());
      }
    } catch {
      /* ignore */
    }
  }, [defaultUrl]);

  return url;
}
